(function () {
    'use strict';

    angular
        .module('app')
        .controller('EmailViewDialogCtrl', EmailViewDialogCtrl);

    EmailViewDialogCtrl.$inject = ['$q', 'DialogInstance', 'EntitiesService', 'email'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for showing an email in read only mode.
     */
    function EmailViewDialogCtrl($q, DialogInstance, EntitiesService, email) {
        /* jshint validthis:true */
        var vm = this;
        vm.previewEntityId = null;
        vm.fromEntities = [];
        vm.multiMode = email.data.MultipleFromMode;
        vm.loading = true;
        vm.close = close;
        vm.previewEntityChanged = previewEntityChanged;

        activate();

        function activate() {
            var loadPromises = [];

            if (vm.multiMode) {
                angular.forEach(email.data.OwnerIds, function (fromEntityId) {
                    loadPromises.push(loadEntity(fromEntityId));
                });
            } else {
                loadPromises.push(loadEmailPreview());
            }

            $q.all(loadPromises)
                .then(function () {
                    if (vm.multiMode) {
                        vm.fromEntities = orderEntities(vm.fromEntities, vm.fromEntities[0].EntityTemplate);
                        vm.previewEntityId = vm.fromEntities[0].Id;

                        return previewEntityChanged();
                    } else {
                        vm.loading = false;
                    }
                });
        }

        /**
         * When the selected preview entity is changed. the email preview must be updated.
         *
         */
        function previewEntityChanged() {
            vm.loading = true;

            return loadEmailPreview()
                .then(function () {
                    vm.loading = false;
                });
        }

        /**
         * Load from email preview for vm.previewEntityId
         *
         */
        function loadEmailPreview() {
            return email.getPreview(vm.previewEntityId).then(getPreviewOk, getPreviewError);

            function getPreviewOk(emailPreview) {
                vm.emailPreview = emailPreview;
            }

            function getPreviewError(response) {
                vm.error = 'Unable to load email preview.';
            }
        }

        /**
         * Load from entity for the supplied id.
         *
         * @param {int} entityId - Identifier for an entity.
         */
        function loadEntity(entityId) {
            return EntitiesService.get(entityId).then(getEntityOk, getEntityError);

            function getEntityOk(data) {
                vm.fromEntities.push(data);
            }

            function getEntityError(response) {

            }
        }

        /**
         * Get the ordered list of entities.
         *
         * @param {array} entities - List of entities which are to be ordered.
         * @param {object} entityTemplate - Entity template to be used for ordering the entities.
         * @return {array} Return a list of ordered entities.
         */
        function orderEntities(entities, entityTemplate) {
            if (!_.isNil(entityTemplate.OrderSetting) && !_.isNil(entityTemplate.OrderSetting.Default)) {
                var orderOption = _.find(entityTemplate.OrderSetting.Options, function (option) {
                    return option.Name === entityTemplate.OrderSetting.Default;
                });

                if (!_.isNil(orderOption)) {
                    var orderFieldList = [];
                    var orderDirectionList = [];

                    angular.forEach(orderOption.Fields, function (field) {
                        if (!_.isNil(field.Name) && field.Name !== '') {
                            orderFieldList.push(field.Name.replace('fields|', 'Fields.'));
                            orderDirectionList.push(field.Order);
                        }
                    });

                    entities = _.sortByOrder(entities, orderFieldList, orderDirectionList);
                }
            }

            return entities;
        }

        function close() {
            DialogInstance.ok();
        }
    }
})();
